import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-confirm-alias-fields",
  templateUrl: "./confirm-alias-fields.component.html",
  styleUrls: ["./confirm-alias-fields.component.scss"]
})
export class ConfirmAliasFieldsComponent implements OnInit {
  message;

  constructor(
    public dialogRef: MatDialogRef<ConfirmAliasFieldsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      changeFlieds;
    },
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.showChangedFieldsMessage(this.data.changeFlieds);
  }

  showChangedFieldsMessage(changedFields: string[]) {
    const translatedFields = changedFields.map(field =>
      this.translate.instant(`detail-tenant.${field}Message`)
    );

    const fieldsText = this.formatFieldList(translatedFields);

    this.message = this.translate.instant("detail-tenant.confirmMessage", {
      fields: fieldsText
    });
  }

  private formatFieldList(fields: string[]): string {
    if (fields.length === 1) {
      return fields[0];
    } else if (fields.length === 2) {
      return `${fields[0]}, ${fields[1]}`;
    } else {
      const allButLast = fields.slice(0, -1).join(", ");
      const last = fields[fields.length - 1];
      return `${allButLast} ,${last}`;
    }
  }

  close(option) {
    this.dialogRef.close(option);
  }
}
